import { AsyncPipe, NgIf } from '@angular/common';
import { Component, forwardRef, input, Input, output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import moment from 'moment-timezone';
import { Observable, of } from 'rxjs';
import { timezoneValidator } from '../../validators/timezone-validator';

@Component({
  selector: 'app-timezone-filter',
  standalone: true,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TimezoneFilterComponent),
    multi: true,
  }],
  imports: [
    MatFormFieldModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatInputModule,
    AsyncPipe,
    FormsModule,
    NgIf
  ],
  templateUrl: './timezone-filter.component.html',
  styleUrl: './timezone-filter.component.scss'
})
export class TimezoneFilterComponent implements ControlValueAccessor {
  filteredOptions!: Observable<string[]>;
  validTimezone = false;
  timeZones: string[] = moment.tz.names();
  selectedTimezone!: string;
  validatorFunction = timezoneValidator(this.timeZones)
  @ViewChild('timezoneModel') timezoneModel!: NgModel;
  @Input() isRequired: boolean = true;


  private onChange!: (value: string) => void;
  onTouched = () => { };

  writeValue(obj: any): void {
    this.selectedTimezone = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInput(event: any): void {
    this.filteredOptions = of(this._filter(event));
    this.onChange(event);
  }
  private _filter(value: string): string[] {
    this.validatorFunction(this.timezoneModel.control)
    const filterValue = value.toLowerCase();
    return this.timeZones.filter(option => option.toLowerCase().includes(filterValue));
  }
}
